import styled from 'styled-components';
import { colorBlack900, fontFamilyRoboto, mediaQueryDesktopMin, mediaQueryMobileLargeMin } from 'styleUtils';
export var CheckboxesBlockWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-154xj8g-0"
})(["display:flex;flex-direction:column;margin-bottom:24px;@media ", "{width:", ";}@media ", "{width:auto;margin-bottom:0;}"], mediaQueryMobileLargeMin, function (_ref) {
  var isWithoutWidth = _ref.isWithoutWidth;
  return isWithoutWidth ? 'auto' : '33.333%';
}, mediaQueryDesktopMin);
export var CheckboxesBlockTitle = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-154xj8g-1"
})(["display:block;margin-bottom:", ";font-family:", ";font-weight:500;font-size:13px;line-height:13px;color:", ";"], function (_ref2) {
  var isCustomTitleMargin = _ref2.isCustomTitleMargin;
  return isCustomTitleMargin ? '16px' : '20px';
}, fontFamilyRoboto, colorBlack900);